"use client";
import { ShellLink } from "@/src/components";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";

interface BreadcrumbProps {
  className?: string;
  data: Array<{ name: string; href?: string }>;
}
export const Breadcrumb = ({ className, data }: BreadcrumbProps) => {
  return (
    <div className={cn("flex items-center title_s", className)}>
      {data.map((item, index) => {
        const isLast = index === data.length - 1;
        const itemKey = `${item.href ?? "no-href"}-${item.name}-${index}`;

        return (
          <div key={itemKey} className="flex items-center">
            {item.href && !isLast ? (
              <ShellLink
                title={item.name}
                aria-label={item.name}
                data-openreplay-label={`${`${item.name} Link`} | ${item.href}`}
                id="lnk-breadcrumb"
                href={item.href}
                className="text-content_tertiary hover:text-content_primary transition-colors"
              >
                {item.name}
              </ShellLink>
            ) : (
              <span
                className={
                  isLast ? "text-content_quaternary cursor-not-allowed" : ""
                }
              >
                {item.name}
              </span>
            )}

            {!isLast && (
              <Icon
                name="chevron-right"
                size={12}
                className="mx-1 text-content_tertiary"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
